import React from "react";
import classNames from "classnames";
import { useLogout } from "@hooks/useLogout";
import { HStack } from "@design-system/HStack/HStack";
import { StateAwareLink } from "@components/routes/StateAwareLink";
import { ChildrenProps } from "../../types";
import { Button } from "@design-system/Button/Button";
import { KickLogo } from "@design-system/KickLogo/KickLogo";
import styles from "./MobileBlock.module.scss";

interface MobileBlockProps extends ChildrenProps {
    icon: React.ReactNode;
    heading: string;
    fullscreen?: boolean;
    showHomeButton?: boolean;
    showLogoutButton?: boolean;
}

export const MobileBlock: React.FC<MobileBlockProps> = ({
    icon,
    heading,
    children,
    fullscreen,
    showHomeButton = false,
    showLogoutButton = false,
}) => {
    const logout = useLogout();

    return (
        <div
            className={classNames(styles.blocker, {
                [styles.fullscreen]: fullscreen,
            })}
        >
            <KickLogo
                variant="icon"
                size="lg"
                label="Kick"
                className={styles.logo}
            />

            <div className={styles.icon}>{icon}</div>

            <h1 className={styles.heading}>{heading}</h1>

            {children}

            <HStack gap={8}>
                {showHomeButton && (
                    <Button asChild variant="primary" size="sm">
                        <StateAwareLink to="/">Go home</StateAwareLink>
                    </Button>
                )}

                {showLogoutButton && (
                    <Button variant="primary" size="sm" onClick={logout}>
                        Log out
                    </Button>
                )}
            </HStack>
        </div>
    );
};
